import { Route, Routes } from 'react-router-dom';
import './App.css';
import { DrawerProvider } from './controller/context/DrawerWidthContext';
import { TitleProvider } from './controller/context/TitleContext';
import Layout from './layout';
import Login from './auth/Login';
import Register from './auth/Register';
import ProtectedRoute from './auth/authRoutes/ProtectedRoutes';
import { routes } from './data/routes';
import { Account } from './account';
import { useEffect } from 'react';
import axios from 'axios';
import { API } from './controller/api';
import { UpdateProvider } from './controller/context/UpdateContext';
import { SelectedIDProvider } from './controller/context/SelectedIdContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IqWriter } from './components/Writers/IqWriter';
import { DocumentHub } from './components/Writers/DocumentHub';
import { ThemeContextProvider } from './controller/context/ThemeContext';
import { Editor } from './components/Writers/Editor';
import { JdWriter } from './components/Writers/JdWriter';
import { JpWriter } from './components/Writers/JpWriter';
import { FpGenie } from './components/Writers/FpGenie';
import VideoTrainingLayout from './components/VideoTrainingLayout';
import SprintTrainingLayout from './components/Sprints';
import useAxiosInterceptor from './controller/hooks/useAxiosInterceptor';
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import { TranslateButtonProvider } from './controller/context/TranslateButtonContext';
import {ResumeReviewer} from './components/Writers/ResumeReviewer';
import { DocumentViewer } from './components/Writers/ResumeReviewer/documentViewer';


function App() {
  useAxiosInterceptor();
useEffect(()=>{
 const wakeUp = async () => {
    const response = await axios.get(API + '/wake-up')
    console.log(response.data)
  
  
 }  
 wakeUp()
},[])
  return (
    <div className="App">
      <ThemeContextProvider>
        <SelectedIDProvider>
          <UpdateProvider>
            <TranslateButtonProvider>
            <TitleProvider>
              <DrawerProvider>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/sprint" element={<SprintTrainingLayout />} />

                  <Route
                    path="/"
                    element={
                      <ProtectedRoute requireSubscription={true}>
                        <Layout />
                      </ProtectedRoute>
                    }
                  >
                    {routes.map((i, idx) => (
                      <Route key={idx} path={i.route} element={i.component} />
                    ))}
                    <Route path="/dc" element={<DocumentHub />} />
                    <Route path="/iq-writer" element={<IqWriter />} />
                    <Route path="/jd-writer" element={<JdWriter />} />
                    <Route path="/jp-writer" element={<JpWriter />} />
                    <Route path="/fp-genie" element={<FpGenie />} />
                    <Route path="/resume-reviewer" element={<ResumeReviewer />} />
                    <Route path="/editor" element={<Editor />} />
                    <Route path="/view-document" element={<DocumentViewer />} />
                    <Route path="/account" element={<Account />} />
                  </Route>
{/* 
                  <Route
                    path="/account"
                    element={
                      <ProtectedRoute requireSubscription={false}>
                        <Account />
                      </ProtectedRoute>
                    }
                  /> */}

                  <Route
                    path="/training"
                    element={
                      <ProtectedRoute requireSubscription={true}>
                        <VideoTrainingLayout />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </DrawerProvider>
            </TitleProvider>
            </TranslateButtonProvider>
          </UpdateProvider>
        </SelectedIDProvider>
      </ThemeContextProvider>
    </div>
  );
}

export default App;
